import api, { handleAPIErrors } from "shared/api";

const FETCH_REQUEST = "entitySearches/FETCH_REQUEST";
const FETCH_SUCCESS = "entitySearches/FETCH_SUCCESS";
const FETCH_FAILURE = "entitySearches/FETCH_FAILURE";
const CLEAR_RESULTS = "entitySearches/CLEAR_RESULTS";

const initialState = {
  result: [],
  loading: false,
  loaded: false,
  errors: {},
};

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  };
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  };
}

export function fetchFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  };
}

export function clearResults() {
  return {
    type: CLEAR_RESULTS,
  };
}

export function searchEntities(options, callback) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api(`api/v1/entity_searches`, options)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        const payload =
          options && options.companyOnly
            ? Array.isArray(json)
              ? json.filter((item) => item?.searchable_type === "Company")
              : json
            : json;

        dispatch(fetchSuccess(payload));

        if (callback) callback(true);
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors));
        });
        callback(false);
      });
  };
}

export function searchCompany(options, callback) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api(`api/v1/entity_searches`, options)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        const payload =
          options && options.companyOnly
            ? Array.isArray(json)
              ? json.filter((item) => item?.searchable_type === "Company")
              : json
            : json;

        dispatch(fetchSuccess(payload));

        callback(true, payload);
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors));
        });
        callback(false);
      });
  };
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload,
      });
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...state.result,
        },
        errors: errors,
      };
    case CLEAR_RESULTS:
      return {
        ...state,
        result: [],
        loading: false,
        loaded: false,
        errors: {},
      };
    default:
      return state;
  }
}
